// src/App.tsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import { WarningOutlined } from "@ant-design/icons";
import "./App.css";
import Toaster from "./components/Toaster/Toaster";
import { AuthProvider } from "./components/Login/AuthContext";
import ProtectedRoute from "./components/Login/PrivateRoute";
import LandingPage from "./components/Dashboard/LandingPage/LandingPage";
import 'bootstrap/dist/css/bootstrap.min.css';
import ResetPassword from "./components/ResetPassword/ResetPassword";
import SSO from "./components/SSO/SSO";
import DeviceReview from "./components/DeviceReview/DeviceReview";
import SetPassword from "./components/SetPassword/SetPassword";

const App: React.FC = () => {
  const currentEnv = import.meta.env.VITE_ENV;
  const version = import.meta.env.VITE_VERSION;

  return (
    <>
      {currentEnv === "dev" && (
        <div className="env-alert">
          <p className="env-alert-text">
            <WarningOutlined className="env-alert-icon" />
            Staging Environment | version {version}
          </p>
        </div>
      )}
      <Router>
        <AuthProvider>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={<ProtectedRoute element={<Dashboard />} />}
            />
            <Route
              path="/dashboard/:section"
              element={<ProtectedRoute element={<Dashboard />} />}
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/sso" element={<SSO />} />
            <Route path="/security/review" element={<DeviceReview />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/try-now-landing-page/:platform" element={<LandingPage />} />
          </Routes>
        </AuthProvider>
      </Router>
    </>
  );
};

export default App;
